import React from "react";
import PropTypes from "prop-types";
import useController from "../../controller";
import BaseIcon from "../../../BaseIcon";
import "./style.scss";
export default function BaseSwiperModal({
  children,
  title,
  description,
  eventTypeModal,
  onPayload,
  className,
  titleStyle,
  contentStyle,
  descriptionStyle,
  onClose,
  isNeonTitle,
}) {
  BaseSwiperModal.propTypes = {
    children: PropTypes.node,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    eventTypeModal: PropTypes.string,
    onPayload: PropTypes.func,
    onClose: PropTypes.func,
    className: PropTypes.string,
    titleStyle: PropTypes.string,
    contentStyle: PropTypes.string,
    descriptionStyle: PropTypes.string,
    isNeonTitle: PropTypes.bool,
  };
  const { closeModal, isModalOpen } = useController(
    eventTypeModal,
    onPayload,
    onClose
  );
  const modalCls = ["base-swiper-modal base-swiper-modal__overflow"];
  const titleCls = ["base-swiper-modal__title"];
  const actionsCls = ["base-swiper-modal__actions"];
  const descriptionCls = [
    "base-swiper-modal__description base-swiper-modal__overflow__description",
  ];
  if (className) modalCls.push(className);
  if (titleStyle) titleCls.push(titleStyle);
  if (contentStyle) actionsCls.push(contentStyle);
  if (descriptionStyle) descriptionCls.push(descriptionStyle);
  return (
    isModalOpen && (
      <div className="modal-container">
        <div
          onClick={closeModal}
          id="modal-swiper-backdrop"
          className="modal-swiper-backdrop"
        />
        <div className={modalCls.join(" ")}>
          <div
            onClick={closeModal}
            id="cross-close"
            className="base-swiper-modal__cross-close-container"
          >
            <BaseIcon
              name="close_cross"
              className="base-swiper-modal__cross-close-container__icon"
            />
          </div>
          <div className={titleCls.join(" ")}>{title}</div>
          {description && (
            <div className={descriptionCls.join(" ")}>{description}</div>
          )}
          <div className={actionsCls.join(" ")}>{children}</div>
        </div>
      </div>
    )
  );
}
